import React from 'react';

import { useCurrentTheme } from 'app/shared/theme';
import { useIsBreakpointSize } from 'app/shared/utils/useBreakpoint';
import { Box, Typography } from 'app/shared/components/atoms';

import TicketPrice from './TicketPrice';

interface EventCTAPriceAndDescriptionProps {
  bookingFeeMessage: string | null;
  earlyBirdOriginalTicketPrice: number;
  isEarlyBird?: boolean;
  shouldDisplayBookingFeeMessage: boolean;
  ticketPrice: number;
  ticketCurrency: string;
}

export const EventCTAPriceAndDescription = ({
  bookingFeeMessage,
  earlyBirdOriginalTicketPrice,
  isEarlyBird,
  shouldDisplayBookingFeeMessage,
  ticketPrice,
  ticketCurrency,
}: EventCTAPriceAndDescriptionProps) => {
  const { isMobile } = useIsBreakpointSize();
  const { dimensions } = useCurrentTheme();

  const BookingFeeMessage = () => {
    if (!shouldDisplayBookingFeeMessage || !bookingFeeMessage) {
      return null;
    }

    return (
      <Typography
        pr={dimensions.horizontalPadding.pageGridItem}
        fontSize="fontSize75"
      >
        {bookingFeeMessage}
      </Typography>
    );
  };

  const containerGap = isEarlyBird ? 0 : isMobile ? 1 : 3;

  return (
    <>
      <Box
        gap={containerGap}
        flexDirection={isMobile ? 'column' : 'row'}
        justifyContent={isMobile ? 'center' : 'flex-start'}
        alignItems={isMobile ? 'flex-start' : 'center'}
        flex="1"
      >
        <TicketPrice
          isEarlyBird={isEarlyBird}
          earlyBirdOriginalPrice={earlyBirdOriginalTicketPrice}
          ticketPrice={ticketPrice}
          currencySymbol={ticketCurrency}
        />
        {BookingFeeMessage()}
      </Box>
    </>
  );
};
